// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"241":"9652471f","341":"b49bd283","421":"b49bd283"}[chunkId] + ".css";
};